function testimonialCheckArrows() {
	//disable .prev when nothing is before
	if ( $('.testimonials-nav-authors > li:first-child').hasClass('active') ) {
		$('.testimonials-nav-arrows > .prev').addClass('disabled');
	} else {
		$('.testimonials-nav-arrows > .prev').removeClass('disabled');
	}
	
	//disable .next when nothing is before
	if ( $('.testimonials-nav-authors > li:last-child').hasClass('active') ) {
		$('.testimonials-nav-arrows > .next').addClass('disabled');
	} else {
		$('.testimonials-nav-arrows > .next').removeClass('disabled');
	}
}

function testimonialActivate(quoteTarget) {
	$('.testimonials-quotes > li').removeClass('active').eq(quoteTarget).addClass('active');
	
	$('.testimonials-nav-authors > li').removeClass('active').removeClass('next').removeClass('prev').removeClass('end').eq(quoteTarget).addClass('active');
	$('.testimonials-nav-authors > li:eq(' + (quoteTarget + 1) + ')').addClass('next');
	$('.testimonials-nav-authors > li:eq(' + (quoteTarget + 2) + ')').addClass('next').addClass('end');
	
	if(quoteTarget - 1 >= 0){
		$('.testimonials-nav-authors > li:eq(' + (quoteTarget - 1) + ')').addClass('prev');
	}
	
	if(quoteTarget - 2 >= 0){
		$('.testimonials-nav-authors > li:eq(' + (quoteTarget - 2) + ')').addClass('prev').addClass('end');
	}
	
	var nextTotal = $('.testimonials-nav-authors > li.next').length,
		prevTotal = $('.testimonials-nav-authors > li.prev').length;
	
	$('.testimonials-nav-authors > li.active').removeClass('end').removeClass('next').removeClass('prev');
	
	if(nextTotal === 1) {
		$('.testimonials-nav-authors > li.prev').removeClass('end');
		
		if(quoteTarget - 2 >= 0){
			$('.testimonials-nav-authors > li:eq(' + (quoteTarget - 2) + ')').addClass('end');
		}
		if(quoteTarget - 3 >= 0){
			$('.testimonials-nav-authors > li:eq(' + (quoteTarget - 3) + ')').addClass('prev').addClass('end');
		}
	} else if (nextTotal === 0) {
		$('.testimonials-nav-authors > li.prev').removeClass('end');
		
		if(quoteTarget - 3 >= 0){
			$('.testimonials-nav-authors > li:eq(' + (quoteTarget - 3) + ')').addClass('prev').addClass('end');
		}
		if(quoteTarget - 4 >= 0){
			$('.testimonials-nav-authors > li:eq(' + (quoteTarget - 4) + ')').addClass('prev').addClass('end');
		}
	}
	
	if(prevTotal === 1) {
		$('.testimonials-nav-authors > li.next').removeClass('end');
		$('.testimonials-nav-authors > li:eq(' + (quoteTarget + 2) + ')').addClass('end');
		$('.testimonials-nav-authors > li:eq(' + (quoteTarget + 3) + ')').addClass('next').addClass('end');
	} else if (prevTotal === 0) {
		$('.testimonials-nav-authors > li.next').removeClass('end');
		$('.testimonials-nav-authors > li:eq(' + (quoteTarget + 3) + ')').addClass('next').addClass('end');
		$('.testimonials-nav-authors > li:eq(' + (quoteTarget + 4) + ')').addClass('next').addClass('end');
	}
	
	$('.testimonials-nav-authors > li.active').removeClass('end').removeClass('next').removeClass('prev');
	
	testimonialCheckArrows();
}

function testimonialPrev() {
	var quoteCurrent = $('.testimonials-quotes > li.active').index(),
		quoteTarget = quoteCurrent - 1;
	
	if(quoteTarget <= 0) {
		quoteTarget = 0;
	}
	
	testimonialActivate(quoteTarget);
}

function testimonialNext() {
	var quoteCurrent = $('.testimonials-quotes > li.active').index(),
		quotesTotal = $('.testimonials-quotes > li').length - 1,
		quoteTarget = quoteCurrent + 1;
	
	if(quoteTarget > quotesTotal) {
		quoteTarget = quotesTotal;
	}
	
	testimonialActivate(quoteTarget);
}

function adjustTestimonialHeight() {
	var testimonialsHeight = 0;
	
	$('.testimonials-quotes > li').each(function() {
		var testimonialHeight = $(this).outerHeight();
		
		if(testimonialHeight > testimonialsHeight){
			testimonialsHeight = testimonialHeight;
			$('.testimonials-quotes').height(testimonialsHeight);
		}
	});
}

function adjustTestimonialWidth() {
	var testimonialWidth = $('#testimonials .testimonials-nav-authors').width();
	if($(window).width() <= 400) {
		$('#testimonials .testimonials-nav-authors > li, #testimonials .testimonials-nav-authors > li > cite').width(testimonialWidth);
	} else {
		$('#testimonials .testimonials-nav-authors > li, #testimonials .testimonials-nav-authors > li > cite').width('');
	}
}

$(document).ready(function() {
	$('.testimonials-nav-arrows > .prev > a').click(function(e) {
		e.preventDefault();
		
		if( !$(this).parent().hasClass('disabled') ) {
			testimonialPrev(); 
		}
	});
	
	$('.testimonials-nav-arrows > .next > a').click(function(e) {
		e.preventDefault();
		
		if( !$(this).parent().hasClass('disabled') ) {
			testimonialNext(); 
		}
	});
	
	$('.testimonials-nav-authors > li').click(function() {
		var testimonialNumber = $(this).index();
		testimonialActivate(testimonialNumber);
	});
	
	adjustTestimonialHeight();
	adjustTestimonialWidth();
	testimonialCheckArrows();
	
	$(window).resize(function() {
		adjustTestimonialHeight();
		adjustTestimonialWidth();
	});
});